
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/case-study/qatar-insurance-company",
      function () {
        return require("private-next-pages/case-study/qatar-insurance-company.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/case-study/qatar-insurance-company"])
      });
    }
  